import React from "react";
import "./Section2.css";

const Section2 = () => {
  return (
    <section className="section2-hdt">
      <div className="section2-container-hdt">

        <div className="section2-grid-hdt">

          {/* LEFT TEXT */}
          <div className="section2-left-hdt">

            <div className="section2-tag-hdt">
              <span>Ce que nous offrons</span>
              <div className="section2-line-hdt"></div>
            </div>

            <h2 className="section2-title-hdt">
              Une Expérience
              <br />
              Unique Pour Vous
            </h2>

            <p className="section2-text-hdt">
              Nous vous proposons des produits américains de qualité ainsi qu’un service
              pensé pour rendre vos achats simples, rapides et agréables.
            </p>

          </div>

          {/* FEATURES */}
          <div className="section2-features-hdt">

            <div className="feature-card-hdt">
              <div className="feature-icon-hdt">🛒</div>

              <h3>Large choix de produits</h3>

              <p>
                Nous mettons à votre disposition une grande variété de produits
                américains pour répondre à toutes vos envies.
              </p>
            </div>

            <div className="feature-card-hdt feature-card-active-hdt">
              <div className="feature-icon-hdt">⭐</div>

              <h3>Qualité garantie</h3>

              <p>
                Nous sélectionnons avec soin des produits de qualité afin de vous
                offrir le meilleur des saveurs et des marques américaines.
              </p>
            </div>

            <div className="feature-card-hdt">
              <div className="feature-icon-hdt">🚚</div>

              <h3>Achat facile</h3>

              <p>
                Nous vous offrons une expérience d’achat simple, rapide et pratique
                pour trouver facilement les produits que vous recherchez.
              </p>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default Section2;